export class Msisdn {
  public static encodeMsisdn(msisdn: string): string | null {
    return !msisdn ? null : parseInt(msisdn, 10).toString(36);
  }

  public static decodeMsisdn(msisdn: string | null, withPlus = false): string | null {
    if (!msisdn) { return null; }

    const decodedMsisdn = parseInt(msisdn, 36).toString(10);
    return withPlus ? `+${decodedMsisdn}` : decodedMsisdn;
  }
}
